module.exports = __webpack_public_path__ + "static/media/gender-women-primary.8fe02aa2.svg";